var a = (t, o, r) => new Promise((c, p) => {
  var s = (e) => {
    try {
      n(r.next(e));
    } catch (i) {
      p(i);
    }
  }, f = (e) => {
    try {
      n(r.throw(e));
    } catch (i) {
      p(i);
    }
  }, n = (e) => e.done ? c(e.value) : Promise.resolve(e.value).then(s, f);
  n((r = r.apply(t, o)).next());
});
import { selfAxios as l } from "@oppein/op-utils";
function d(t) {
  return a(this, null, function* () {
    const { data: o } = yield l.post(
      "/production-order/engineering/bpmSpecialFlow/create",
      t
    );
    return o == null ? void 0 : o.data;
  });
}
export {
  d as postCreate
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/engineering/bpmSpecialFlow/create/post.js
// module id = 1827
// module chunks = 67